import { smartIdApi } from '../../../utils/smartIdApi.js';
import SmartIdErrorMessagesService from '../../services/SmartIdErrorMessagesService.js';
import SmartIdValidator from '../../components/SmartIdValidator';
import LegalEntityFunctions from '../../components/LegalEntityFunctions';
import * as constants from '../../constants/constants';
import { SMART_ID_POLLING_RESULT } from '../../account/SmartId/Shared/smartIdConstants';

export class SmartIdRegistrationService {
  constructor() {
    this.smartIdPollingComplete = false;
  }

  validatePersonalCodeFormatting(personalCode) {
    const legalEntityId = LegalEntityFunctions.getLegalEntityId(localStorage.getItem(constants.SELECTED_COUNTRY));
    const validation = SmartIdValidator.validatePersonalCode(personalCode, legalEntityId);
    return validation;
  }

  async startSmartIdRegistrationSession(personalCode, selectedCountry) {
    const result = await smartIdApi.startRegistrationSession(personalCode, selectedCountry);
    
    if (!result.success) {
      return { success: false, error: result.error };
    }

    return { success: true, pin: result.data };
  }

  async pollSmartIdRegistrationSession() {
    if (this.smartIdPollingComplete) {
      return { success: false, complete: true };
    }

    try {
      const legalEntityId = LegalEntityFunctions.getLegalEntityId(localStorage.getItem(constants.SELECTED_COUNTRY));
      const result = await smartIdApi.pollRegistrationSession(legalEntityId);

      if (result.status === SMART_ID_POLLING_RESULT.SUCCESS) {
        const isPersonalCodeRegisteredResult = await smartIdApi.isPersonalCodeRegistered();
        if (isPersonalCodeRegisteredResult.success && isPersonalCodeRegisteredResult.data === true) {
          this.smartIdPollingComplete = true;
          return { success: false, error: 'personal_code_duplicate' };
        } 
        this.smartIdPollingComplete = true;
        const personalInfo = result.personalInfo;
        
        return {
          success: true,
          personalInfo: {
            firstName: personalInfo.firstName,
            lastName: personalInfo.lastName,
            birthDate: personalInfo.birthDate
          }
        };
      } else if (result.status === SMART_ID_POLLING_RESULT.ERROR || result.status === SMART_ID_POLLING_RESULT.EXPIRED) {
        this.smartIdPollingComplete = true;
        return { success: false, error: result.error };
      }

      // Continue polling
      return { success: false, continue: true };
    } catch (error) {
      this.smartIdPollingComplete = true;
      const errorMessage = SmartIdErrorMessagesService.getErrorMessage('smart_id_polling_error');
      return { success: false, error: errorMessage };
    }
  }

  cancelSmartIdRegistration() {
    this.smartIdPollingComplete = true;
  }

  resetPolling() {
    this.smartIdPollingComplete = false;
  }
} 